import {ZoneId} from "./nominalTypes/ZoneId";
import {InstallationByHostData} from "./types/InstallationByHostData";
import {IntegraHolderData} from "./types/IntegraHolderData";
import {IntegraZone} from "./types/IntegraZone.js";

class Zones {
	static get(value: InstallationByHostData, zoneId: ZoneId | undefined): IntegraZone {
		if (!zoneId) {
			return {
				id: "" as ZoneId,
				name: "—"
			};
		}

		let zone = value.zones.find((x) => x.id === zoneId);
		if (zone != null) {
			return zone;
		}

		return {
			id: zoneId,
			name: "—"
		};
	}

	static getAll(value: InstallationByHostData, zoneIds: ZoneId[]): IntegraZone[] {
		return zoneIds.map(t => this.get(value, t));
	}
}

export {Zones};
